<template>

  <v-app style="background-color: #2f2f2f;">

    <!-- <v-content> -->

      <!-- Error Messages -->    
      <app-errors></app-errors>     


      <!-- Loading progress icon -->
      <app-loader></app-loader>


      <v-container fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>  

            <!-- <v-tabs 
              icons-and-text 
              centered 
              dark 
              color="primary"
              hide-slider 
              class="elevation-12"
            >
                <v-tab href="#login">
                  {{ $t('label.login') }}
                  <v-icon>mdi-login-variant</v-icon>
                </v-tab>

                <v-tab href="#signup">
                  {{ $t('label.signup') }}
                  <v-icon>mdi-account-plus</v-icon>
                </v-tab>      

                <v-tab-item :value="'login'">  -->



                  <v-card flat dark color="#2f2f2f">

                    <div class="center">
                      <h1>PowerBOM</h1>
                      <br>
                      <p class="text-center" style="font-size: 20px">An AWE Job Guidance Application</p>
                    
                    <!-- <i class="material-icons md-48">list_alt</i> -->


                      <img
                        height="192px"
                        width="192px"
                        src="img/icons/list_icon.png"
                      />
                    </div>

                    <v-card-text>

                      <v-form ref="login_form">
                        <v-text-field
                          id="login_username"
                          prepend-icon="mdi-account"
                          :label="$t('label.username')"
                          type="text"
                          v-model="login_username"
                          v-validate.disable="{ required: true }"
                          data-vv-name="login_username"
                          :data-vv-as="$t('label.username')"
                          :error-messages="errors.collect('login_username')"
                        >
                        </v-text-field>
                        <v-text-field 
                          id="login_password" 
                          prepend-icon="mdi-lock-question"   
                          :label="$t('label.password')"
                          :type="show_password ? 'text' : 'password'"
                          v-model="login_password"
                          v-on:keyup.enter="onLogin"  
                          :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="show_password = !show_password"
                          v-validate.disable="{ required: true }"
                          data-vv-name="login_password"
                          :data-vv-as="$t('label.password')"  
                          :error-messages="errors.collect('login_password')"                         
                        >
                        </v-text-field>
                      </v-form>
                    </v-card-text>
                    <v-card-actions> 
                      <v-spacer></v-spacer>
                      <v-btn text @click.prevent="onLogin">{{ $t('label.login') }}</v-btn>
                    </v-card-actions>
                    <!-- <v-list dense>
                      <v-list-item>
                        <router-link to="/signin">{{ $t('label.change_password') }}</router-link>
                        <v-spacer></v-spacer>
                        <router-link to="/signin">{{ $t('label.forgot_password') }}</router-link>
                      </v-list-item>
                    </v-list> -->
                    <!-- <app-locale-switcher></app-locale-switcher> -->
                  </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      
    <!-- </v-content> -->

  </v-app>

</template>


<script>
 
  import { locales } from '@/config/i18n'

  export default {

    data () {
      return {

        login_username: '',
        login_password: '',

        show_password: false, 

        signup_username: '',
        signup_password: '',
        confirmpassword: '', 
        
        locales,
      }
    },


    methods: {

      onLogin () {

        // 

        this.$validator.validate().then(async (result) => {
          if (result) {
            const formData = {
              Email: this.login_username,
              Password: this.login_password,
            };
            await this.$store.dispatch('login', formData);

            this.$router.replace('/tasks').catch(err => {}) 
          }
        })
      }

    },

    created () {

      this.$vuetify.theme.primary ="#fff"
      
      // this.$store.dispatch('tryAutoLogin')
      
      // Set rtl
      var currLocalCode = this.$i18n.locale 
      var currLocaleDetails = this.locales.find( obj => obj.code == currLocalCode )

      if (currLocaleDetails.dir == 'rtl') {
          this.$vuetify.rtl = true
      } else {
          this.$vuetify.rtl = false
      }

      // Store default locale in local storage for later use throughout the app
      // as it is not persisted during page refreshes
      localStorage.setItem('currentLocale', this.$i18n.locale )
      localStorage.setItem('currentRTL', this.$vuetify.rtl ) 
  
    },

  }
</script>

<style>

  .center {
    text-align: center;
  }



</style>

